import React, { useState, useEffect } from "react";
import Preloader from "../src/components/Pre";
import Navbar from "./components/Navbar";
import Home from "./components/Home/Home";
import About from "./components/About/About";
import Registration from "./components/Registration/Registration";
import Projects from "./components/Projects/Projects";
import AdmissionsPage from "./components/Career/AdmissionsPage";
import CatalogPage from "./components/Career/CatalogPage";
import StudentResourcesPage from "./components/Career/StudentResourcesPage";
import Footer from "./components/Footer";
import Team from "./components/Team/Team";
import WebPricing from "./components/WebPricing/PricingCard1";
import RoboticsPricing from "./components/RoboticsPricing/RoboticsCard"
import ThreeDWebPricing from "./components/ThreeDWebPricing/ThreeDWebCard"
import ThreeDModelingPricing from "./components/ThreeDModelingPricing/ThreeDModelingCard"
import JusticeTechPricing from "./components/JusticeTechPricing/JusticeTechCard"
import AppropTechPricing from "./components/AppropTechPricing/AppropTechCard"
import ExploratoryLearning from "./components/ExploratoryLearning/ExploratoryLearning";

// import Impact from "./components/Impact/Impact";
import Contact from "./components/Contact/Contact";
import Lab from "./components/Lab/LabPage";
import Favrhood from "./components/Favrhood/Favrhood";
import ConsultingAdvisory from "./components/ConsultingAdvisory/ConsultingAdvisory";
import HandsOnLearning from "./components/HandsOnLearning/HandsOnLearning";

import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate
} from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import "./style.css";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import ImpactHome from "./components/Activities/ImpactHome";
import Impact from "./components/Impact/Impact"
import Workshop from "./components/Workshops/Workshop";
import Senior from "./components/Seniors/Senior";
import Neighborhood from "./components/Neighborhood/Neighborhood";
import Support from "./components/Support/Support";
import Story from "./components/Story/Story";
import Testimonial from "./components/Testimonials/Testimonial";
import Partners from "./components/Partners/Partners";
import Mission from "./components/Mission/Mission";
import Afterschool from "./components/Afterschool/Afterschool";
import Ambassadors from "./components/Ambassadors/Ambassadors";
import TechPal from "./components/TechPal/TechPal";
import Camps from "./components/Camps/Camps";
import Stats from "./components/Stats/Stats";
import PartnerWithUs from "./components/PartnerWithUs/PartnerWithUs";
import VolunteerOpportunities from "./components/VolunteerOpportunities/VolunteerOpportunities";
import TrainingsTiers from "./components/TrainingsTiers/TrainingsTiers";
import Tiers from "./components/Tiers/Tiers.js";

import GrievanceAppealsPolicy from "./components/Policies/GrievanceAppealsPolicy.js";
import PrivacyPolicy from "./components/Policies/PrivacyPolicy.js";
import TermsOfUse from "./components/Policies/TermsOfUse.js";



function App() {
  const [load, upadateLoad] = useState(true);
  const [theme, setTheme] = useState(() => {
    try {
      const saved = window.localStorage.getItem("cf-theme");
      return saved === "light" || saved === "dark" ? saved : "light";
    } catch {
      return "light";
    }
  });

  useEffect(() => {
    const timer = setTimeout(() => {
      upadateLoad(false);
    }, 250);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    try {
      document.documentElement.setAttribute("data-theme", theme);
      window.localStorage.setItem("cf-theme", theme);
    } catch {
      document.documentElement.setAttribute("data-theme", theme);
    }

    const metaTheme = document.querySelector('meta[name="theme-color"]');
    if (metaTheme) {
      metaTheme.setAttribute("content", theme === "light" ? "#0b6f7d" : "#06161d");
    }
  }, [theme]);

  useEffect(() => {
    let rafId = null;
    let scheduled = false;

    const optimizeImages = () => {
      scheduled = false;
      const viewportHeight = window.innerHeight || 800;
      const images = document.querySelectorAll("img");

      images.forEach((img, idx) => {
        if (!img.hasAttribute("decoding")) {
          img.setAttribute("decoding", "async");
        }

        const rect = img.getBoundingClientRect();
        const nearViewport = rect.top < viewportHeight * 1.25 && rect.bottom > -viewportHeight * 0.25;

        if (!img.hasAttribute("loading")) {
          const shouldEagerLoad = nearViewport && idx < 2;
          img.setAttribute("loading", shouldEagerLoad ? "eager" : "lazy");
        }

        if (!img.hasAttribute("fetchpriority")) {
          const isHeroCandidate = nearViewport && rect.top < viewportHeight * 0.9;
          if (isHeroCandidate && img.getAttribute("loading") === "eager") {
            img.setAttribute("fetchpriority", "high");
          } else if (img.getAttribute("loading") === "lazy") {
            img.setAttribute("fetchpriority", "low");
          }
        }
      });
    };

    const scheduleOptimization = () => {
      if (scheduled) return;
      scheduled = true;
      rafId = window.requestAnimationFrame(optimizeImages);
    };

    scheduleOptimization();

    const observer = new MutationObserver(() => {
      scheduleOptimization();
    });

    if (document.body) {
      observer.observe(document.body, { childList: true, subtree: true });
    }

    window.addEventListener("resize", scheduleOptimization, { passive: true });
    window.addEventListener("load", scheduleOptimization, { once: true });

    return () => {
      observer.disconnect();
      if (rafId !== null) {
        window.cancelAnimationFrame(rafId);
      }
      window.removeEventListener("resize", scheduleOptimization);
      window.removeEventListener("load", scheduleOptimization);
    };
  }, []);

  const toggleTheme = () => {
    setTheme((current) => (current === "dark" ? "light" : "dark"));
  };

  return (
    <Router>
      <Preloader load={load} />
      <div className="App" id={load ? "no-scroll" : "scroll"}>
        <Navbar theme={theme} onToggleTheme={toggleTheme} />
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/courses" element={<Projects />} />
          <Route path="/admissions" element={<AdmissionsPage />} />
          <Route path="/catalog" element={<CatalogPage />} />
          <Route path="/student-resources" element={<StudentResourcesPage />} />
           <Route path="/tiers" element={<Tiers />} />
           <Route path="/programs/trainings-tiers" element={<TrainingsTiers />} />
          <Route path="/about/who-we-are" element={<About />} />
          <Route path="/registration" element={<Registration/>} />
          <Route path="/impact" element={<Stats />} />
          <Route path="/impact/community" element={<ImpactHome />} />
          <Route path="/team" element={<Team/>} />
          <Route path="/about/testimonials" element={<Testimonial/>} />
          <Route path="/contact" element={<Contact />} />          
          <Route path="/web-pricing" element={<WebPricing />} />
          <Route path="/robotics-pricing" element={<RoboticsPricing />} />
          <Route path="/three-d-web-pricing" element={<ThreeDWebPricing />} />
          <Route path="/three-d-modeling-pricing" element={<ThreeDModelingPricing />} />
          <Route path="/justice-tech-pricing" element={<JusticeTechPricing />} />
          <Route path="/approp-tech-pricing" element={<AppropTechPricing />} />
          <Route path="/services/favrhood" element={<Favrhood />} />
          <Route path="/services/consulting-advisory" element={<ConsultingAdvisory />} />
          <Route path="/favrhood" element={<Navigate to="/services/favrhood" replace />} />
          <Route path="/lab" element={<Lab />} />              
          <Route path="/programs/syep-internship" element={<Impact />} />
          <Route path="/programs/hands-on-learning" element={<HandsOnLearning />} />
          <Route path="/programs/exploratory-learning" element={<ExploratoryLearning />} />
          <Route path="/programs/workshops" element={<Workshop />} />
          <Route path="/programs/after-school" element={<Afterschool />} />
          <Route path="/programs/ambassadors" element={<Ambassadors />} />
          <Route path="/programs/tech-pal" element={<TechPal />} />
          <Route path="/programs/partner-with-us" element={<PartnerWithUs />} />
          <Route path="/programs/volunteer-opportunities" element={<VolunteerOpportunities />} />
          <Route path="/programs/tech-camps" element={<Camps />} />
          <Route path="/programs/senior-citizens" element={<Senior />} />
          <Route path="/programs/code-and-soil" element={<Neighborhood />} />
          <Route path="/support" element={<Support />} />
          <Route path="/about/our-story" element={<Story />} />
          <Route path="/about/our-partners" element={<Partners />} />
          <Route path="/about/our-mission" element={<Mission />} />          
          <Route path="/about/impact" element={<Navigate to="/impact" replace />} />            
          <Route path="/policies/grievance-appeals" element={<GrievanceAppealsPolicy />} />
          <Route path="/policies/privacy" element={<PrivacyPolicy />} />
          <Route path="/policies/terms" element={<TermsOfUse />} />
          <Route path="*" element={<Navigate to="/"/>} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
